export enum Provider {
  UNKNOWN_PROVIDER = 'UNKNOWN_PROVIDER',
  FACEBOOK = 'FACEBOOK',
  GOOGLE = 'GOOGLE',
  MICROSOFT = 'MICROSOFT',
}
